import NotesListContainer from './notes_list_container';

const NotesList = NotesListContainer;
export default NotesList;
